import { useState, useEffect, useRef, useCallback } from 'react';

export function useCalcElementDimensions( ){
    // const ref = useRef(null);
    const [ el, setEl ] = useState(null);
    const [ size, setSize ] = useState({ width: 0, height: 0 });

    const setRef = useCallback((node) => {
        setEl(node || null);
    }, []);

    useEffect(() => {
        if( !el || typeof ResizeObserver === "undefined" ) return;
    
        let rafId = 0;
        const obs = new ResizeObserver((entries) => {
            const cr = entries[0] && entries[0].contentRect;
            if (!cr) return;

            const nextW = Math.round(cr.width);
            const nextH = Math.round(cr.height);

            cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                setSize((prev) => {
                    const dw = Math.abs(prev.width - nextW);
                    const dh = Math.abs(prev.height - nextH);
                    // ← ignore les micro-deltas (<2px) pour éviter le ping-pong
                    if( dw < 2 && dh < 2 ) return prev;
                    return { width: nextW, height: nextH };
                });
            });
        });
    
        obs.observe(el);
    
        const rect = el.getBoundingClientRect();
        setSize((prev) => {
            const w = Math.round(rect.width);
            const h = Math.round(rect.height);
            if (prev.width === w && prev.height === h) return prev;
            return { width: w, height: h };
        });
    
        return () => {
            cancelAnimationFrame(rafId);
            try { obs.unobserve(el); } catch {}
            obs.disconnect();
        };
    }, [el]);

    return [ size, setRef ];
}